import {
  HAS_ERROR,
  SHOW_ACTIVITY,
  IS_CONTENT_LOADING,
  IS_PAGE_LOADING,
  SHOW_COLLECTION,
  UPDATE_CURRENT_COLLECTION,
  AFFILIATE_COLLECTION,
  SAVE_FILTERED_ACTIVITIES,
  FILTER_APPLIED,
  LOCATION_FILTER_APPLIED,
  CATEGORY_FILTER_APPLIED,
  AFFILIATE_LOGO,
  PAGE_NOT_FOUND
} from "./constant";

export function loadActivities(activities) {
  return {
    type: SHOW_ACTIVITY,
    activities
  };
}

export function pageLoading(bool) {
  return {
    type: IS_PAGE_LOADING,
    pageLoading: bool
  };
}

export function contentLoading(bool) {
  return {
    type: IS_CONTENT_LOADING,
    contentLoading: bool
  };
}

export function hasError(bool) {
  return {
    type: HAS_ERROR,
    hasError: bool
  };
}
export function collectionFetchSuccess(collections) {
  return {
    type: SHOW_COLLECTION,
    collections
  };
}
export function updateCurrentCollection(collection) {
  return {
    type: UPDATE_CURRENT_COLLECTION,
    collection
  };
}

export function updateAffiliateCollections(collections) {
  return {
    type: AFFILIATE_COLLECTION,
    fromAffiliate: collections
  };
}
export function saveFilteredActivities(activities) {
  return {
    type: SAVE_FILTERED_ACTIVITIES,
    activities: activities
  };
}
export function changeStatusOfFilter(bool) {
  return {
    type: FILTER_APPLIED,
    status: bool
  };
}
export function saveFilteredLocation(location) {
  return {
    type: LOCATION_FILTER_APPLIED,
    location: location
  };
}
export function saveFilteredCategory(category) {
  return {
    type: CATEGORY_FILTER_APPLIED,
    category: category
  };
}
// export function activitiesFetchSuccess(activities){
//     return {
//         type: SHOW_ACTIVITY,
//         activities
//     }
// }
export function getAffiliateLogo(id, logo, username, name) {
  return {
    type: AFFILIATE_LOGO,
    affiliate: { id: id, logo: logo, username: username, name: name }
  };
}
export function pageNotFound(bool) {
  return {
    type: PAGE_NOT_FOUND,
    payload: bool
  };
}
export function fetchCollectionsOfAffiliate(url, currentId) {
  return dispatch => {
    dispatch(contentLoading(true));
    return fetch(url)
      .then(response => response.json())
      .then(json => {
        if (json.status) {
          dispatch(contentLoading(false));
          dispatch(updateAffiliateCollections(json.collections));
          dispatch(getAffiliateLogo(json.affiliateId, json.affiliateLogo, json.affiliateUsername, json.affiliateName));
          var currentCollection = json.collections.filter(element => {
            return element.url === currentId;
          });
          return dispatch(updateCurrentCollection(currentCollection[0]));
        } else {
          return dispatch(pageNotFound(true));
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };
}

export function fetchActivitiesOfCollection(url) {
  return dispatch => {
    dispatch(contentLoading(true));
    return fetch(url)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(data) {
        if (data.status) {
          dispatch(contentLoading(false));
          return dispatch(loadActivities(data.activities));
        } else {
          return dispatch(pageNotFound(true));
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

function parseJSON(response) {
  return response.json();
}



// WEBPACK FOOTER //
// ./src/actions/index.js